export interface IListModel {
  totalCount: number
  totalPageCount: number
  resultCount: number
  morePages: boolean
  currentPage: number
  result: any[]
}

export interface IPaginationModel {
  skip: number
  take: number
}

export interface IFilterModel extends IPaginationModel {
  searchText: string | null
  sortcolumn: string
  sortorder: string
}

export enum ISortOrderEnum {
  asc = 'Ascending',
  desc = 'Descending',
}
